<template>
    <div v-if="(tooltips.length && tip && isMounted)"
         class="ob-tooltip"
         :class="cssClasses"
         :id="`ob-${tipIndex}`"
         :data-ob="tipIndex">

        <div class="ob-top">
            <div style="display: contents" v-if="tooltips.length > 1">
                Tip {{ tipIndex }} of {{ tooltips.length }}
            </div>
            <span class="ob-close">
                <svg class="close"><use xlink:href="#close"></use></svg>
            </span>
        </div>

        <div class="ob-content">
            <p v-text="tip.tip"></p>
        </div>

        <div class="ob-controls" v-if="tooltips.length > 1">
            <button type="button" class="ob-btn ob-prev" :class="{ 'dis' : isFirst }" :disabled="isFirst">
                <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
                Prev
            </button>
            <button type="button" class="ob-btn ob-next" :class="{'dis' : isLast }" :disabled="isLast">
                Next
                <svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg>
            </button>
        </div>
    </div>
</template>
<script>
export default {

    props: ['tooltips', 'name'],

    data(){
        return {
            isMounted: false,
        }
    },

    mounted(){
        let timeout = setTimeout(() => {
            this.isMounted = true;
            clearTimeout(timeout)
        }, 2000)
    },

    computed: {

        tip() {
            return _.find(this.tooltips, tip => {
                return tip.key == this.name
            });
        },

        cssClasses() {
            return this.tip.class + (this.isFirst ? ' active' : '');
        },

        tipIndex() {
             return _.findIndex(this.tooltips, tip => {
                return tip.key == this.name
            }) + 1
        },

        isFirst() {
            return this.tipIndex == 1
        },

        isLast() {
            return this.tipIndex == this.tooltips.length
        }
    }
}
</script>
